import { render } from "./IconLocation.vue?vue&type=template&id=19b19910"
import script from "./IconLocation.vue?vue&type=script&lang=js"
export * from "./IconLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__